import React, { useState } from "react";
import Dropdown from "./Dropdown"; // Import the Dropdown component

export const InputField = ({
    label,
    type = "text",
    name,
    placeholder,
    value,
    options = [], // Add options for select input
    handleChange,
    required = false,
    disabled = false,
    error = ""
}) => {
    const [activeDropdown, setActiveDropdown] = useState(null);

    // Close other dropdowns when one is opened
    const handleDropdownToggle = (dropdownId) => {
        setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
    };

    return (
        <div>
            <label htmlFor={name} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {label}
            </label>
            {type === "select" ? (
                <Dropdown
                    title={
                        options.find((option) => value === option.id || value === option.uuid || value === option.value)?.name ||
                        options.find((option) => value === option.id || value === option.uuid || value === option.value)?.title || placeholder}
                    items={options}
                    onItemSelect={(selectedItem) => {
                        handleChange({
                            target: {
                                name: name,
                                value: selectedItem,
                            },
                        });
                    }}
                    disabled={disabled}
                    id={name}
                    isOpen={activeDropdown === name}
                    onToggle={handleDropdownToggle}
                />
            ) : (
                <>
                    <input
                        type={type}
                        name={name}
                        id={name}
                        placeholder={placeholder}
                        value={value}
                        onChange={handleChange}
                        className={`bg-gray-50 border ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-primary-600 focus:border-primary-600'} text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 ${error ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500' : 'dark:border-gray-600 dark:focus:ring-primary-500 dark:focus:border-primary-500'} dark:placeholder-gray-400 dark:text-white disabled:bg-gray-100 disabled:cursor-not-allowed`}
                        required={required}
                        disabled={disabled}
                        aria-invalid={!!error}
                        aria-describedby={error ? `${name}-error` : undefined}
                    />
                    {error && (
                        <p id={`${name}-error`} className="mt-1 text-xs text-red-600">
                            {error}
                        </p>
                    )}
                </>
            )}
        </div>
    );
};